module.exports = __webpack_public_path__ + "images/mdj/members/resume/resume_end_screen/arrow-down-dad3295a50be8c898c7009b6826e3fe5.png";